(() => {
  const elementName = 'aogeo-resource-library';
  if (!window.customElements || window.customElements.get(elementName)) return;

  const normalize = (value) => String(value || '').normalize('NFKC').toLowerCase();

  class AogeoResourceLibrary extends HTMLElement {
    constructor() {
      super();
      this._ready = false;
      this._onInput = () => this._filter();
      this._onClear = () => this._reset(true);
      this._onJump = (event) => {
        const link = event.target?.closest?.('[data-resource-jump]');
        if (link && this.contains(link) && link.getAttribute('href')?.startsWith('#') && this._input.value) {
          this._reset(false);
        }
      };
    }

    connectedCallback() {
      if (this._ready) return;
      this._controls = this.querySelector('[data-resource-controls]');
      this._input = this.querySelector('[data-resource-search]');
      this._clear = this.querySelector('[data-resource-clear]');
      this._status = this.querySelector('[data-resource-status]');
      this._empty = this.querySelector('[data-resource-empty]');
      if (!this._controls || !this._input || !this._clear || !this._status || !this._empty) return;

      this._entries = Array.from(this.querySelectorAll('[data-resource-entry]'), (node) => ({
        node,
        text: normalize(node.dataset.resourceSearchText)
      }));
      this._groups = Array.from(this.querySelectorAll('[data-resource-group]'), (node) => ({
        node,
        entries: this._entries.filter((entry) => node.contains(entry.node))
      }));
      this._input.addEventListener('input', this._onInput);
      this._clear.addEventListener('click', this._onClear);
      this.addEventListener('click', this._onJump);
      this._ready = true;
      this._filter();
      this._controls.hidden = false;
    }

    disconnectedCallback() {
      if (!this._ready) return;
      this._input.removeEventListener('input', this._onInput);
      this._clear.removeEventListener('click', this._onClear);
      this.removeEventListener('click', this._onJump);
      this._controls.hidden = true;
      this._ready = false;
    }

    _filter() {
      const terms = normalize(this._input.value).trim().split(/\s+/u).filter(Boolean);
      let count = 0;
      this._entries.forEach((entry) => {
        entry.node.hidden = !terms.every((term) => entry.text.includes(term));
        if (!entry.node.hidden) count += 1;
      });
      this._groups.forEach((group) => {
        group.node.hidden = !group.entries.some((entry) => !entry.node.hidden);
      });
      this._empty.hidden = count > 0;
      this._status.textContent = (this.dataset.resultTemplate || '__COUNT__').replaceAll('__COUNT__', String(count));
      this._clear.disabled = !this._input.value;
    }

    _reset(focusInput) {
      this._input.value = '';
      this._filter();
      if (focusInput) this._input.focus();
    }
  }

  window.customElements.define(elementName, AogeoResourceLibrary);
})();
